import { useAiChatStore } from '../../store/aiChatStore';
import './AiChatHead.css';

/**
 * 대화의 «머리» — 지금 읽고 있는 대화가 **무엇인지** 본문이 말한다 (시안 버전 7 · PR6).
 *
 * ## 왜 생겼나
 *
 * 2026-09-12 사용자 지적 「채팅창 디자인이 시안과 다르다」를 시안과 나란히 놓고 재 보니,
 * 시안의 대화 화면에서 **가장 큰 요소가 대화 제목**인데 운영에는 그 자리가 통째로 없었다.
 * 운영이 적는 것은 화면 머리의 「대화」 하나뿐이라(정본 A3 — 제목은 메뉴 이름과 같다),
 * **어느 대화를 보고 있는지**는 좌측 이력에서 굵어진 줄로만 알 수 있었다.
 *
 * ★ 그래서 화면 제목은 **안 건드린다**(A3 는 그대로다). 대화 제목은 «화면의 이름»이 아니라
 *   «지금 읽는 글의 이름»이라 본문의 첫 줄로 들어간다 — 메일에서 「메일」 아래 제목이
 *   따로 서는 것과 같은 자리다.
 *
 * ## 안 그리는 때
 *
 * - 아직 저장 안 된 새 대화(`conversationId === null`) — 이름이 없다. 첫 턴이 끝나면 생긴다.
 * - 이력을 아직 못 읽어 이름을 모를 때 — **「제목 없음」을 지어내지 않는다.**
 * - 말이 하나도 없을 때 — 빈 화면은 가운데 선 인사말이 제 머리를 갖는다.
 */
export function AiChatHead() {
  const id = useAiChatStore((s) => s.conversationId);
  const title = useAiChatStore((s) => s.conversations.find((c) => c.id === s.conversationId)?.title ?? null);
  const agentName = useAiChatStore((s) => s.agent?.name ?? null);
  const count = useAiChatStore((s) => s.messages.length);

  if (id === null || title === null || count === 0) return null;

  return (
    <header className="aichathead">
      <h2 className="aichathead__t">{title}</h2>
      <p className="aichathead__meta">
        <span>{agentName ?? '에이전트 없음'}</span>
        <span>{count}개 말</span>
      </p>
    </header>
  );
}
